class cartUpsell extends HTMLElement {
    constructor() {
      super();

      this.init();
      document.addEventListener("upsell:init", this.init.bind(this));
    };

    init() {
        this.upsellBtn = this.querySelectorAll("[js-upsell-btn]");

        this.initUpsellSlider();

        this.upsellBtn.forEach( btn => {
            btn.addEventListener('click', ({ currentTarget }) => {
                this.upsellAddToCart(currentTarget)
            });
        });
    };

    upsellAddToCart(target) {
        const productId = parseInt(target.dataset.productId);
        target.classList.add("btn--loading");

        const data = {
            id: productId,
            quantity: 1
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
        .then((response) => response.json())
        .then((data) => {
            target.classList.remove("btn--loading");
            document.dispatchEvent(new CustomEvent('cart:build'));
        })
    };

    initUpsellSlider() {
        // const sliders = document.querySelectorAll('[js-upsell-slider]');

        new Swiper ('[js-upsell-slider]', {
          slidesPerView: 2,
          spaceBetween: 16,
          breakpoints: {
            990: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            1320: {
              slidesPerView: 2,
              spaceBetween: 16
            }
          },
        });

        // sliders.forEach(slider => slider.classList.add("slider-initialized"))
    }
}
  
customElements.define('cart-upsell', cartUpsell);
  